import { MarkInPictureQuestionDownloadDto } from 'collaboration-service';
import * as React from 'react';
import EditPartContainer, { EditPartContainerType } from '../EditPartContainer';
import EditPartLabelAndEditor from '../EditPartLabelAndEditor';
import EditColor from '../Editors/EditColor';
import EditImageGrid from '../Editors/EditImageGrid';
import EditNumberWithSlider from '../Editors/EditNumberWithSlider';
import GenPropQuestion from './GenPropQuestion';
import PrePostFixQuestion from './PrePostFixQuestion';
import { GeneralPostEditState } from '../GeneralPostEditStateHandling';
import { shallowCompare } from 'services/Helpers';
import { useSelectorGPE } from '../GeneralPostEdit';

const mapper = (s: GeneralPostEditState) => ({ post: s.post });
interface PostEditQuizMarkInPictureQuestionProps {
    epc: EditPartContainerType;
    registerClosed?: boolean;
}

const PostEditQuizMarkInPictureQuestion = (p: PostEditQuizMarkInPictureQuestionProps) => {
    const { epc, registerClosed } = p;
    const { post: pp } = useSelectorGPE(mapper, shallowCompare);
    const post = pp as MarkInPictureQuestionDownloadDto;
    return (
        <>
            <GenPropQuestion epc={epc} registerClosed={registerClosed} />
            <EditPartContainer icon="asking" title="basic settings" {...epc} >
                <EditPartLabelAndEditor>
                    {[
                        {
                            label: { icon: "color", content: "marker color" }, editor: <EditImageGrid<MarkInPictureQuestionDownloadDto>
                                getter={x => x.correctAnswers!}
                                media={post.media}
                                x={post.xResolution}
                                y={post.yResolution}
                            />
                        },
                        { label: { icon: "color", content: "marker color" }, editor: <EditColor<MarkInPictureQuestionDownloadDto> getter={x => x.markerColor} /> },
                        { label: { icon: "resume", content: "xResolution" }, editor: <EditNumberWithSlider<MarkInPictureQuestionDownloadDto> getter={x => x.xResolution} min={0} max={50} /> },
                        { label: { icon: "resume", content: "yResolution" }, editor: <EditNumberWithSlider<MarkInPictureQuestionDownloadDto> getter={x => x.yResolution} min={0} max={50} /> },
                        { label: { icon: "tag", content: "paddingTop" }, editor: <EditNumberWithSlider<MarkInPictureQuestionDownloadDto> getter={x => x.paddingTop} min={0} max={10} /> },
                        { label: { icon: "tag", content: "paddingLeft" }, editor: <EditNumberWithSlider<MarkInPictureQuestionDownloadDto> getter={x => x.paddingLeft} min={0} max={10} /> },
                        { label: { icon: "tag", content: "paddingRight" }, editor: <EditNumberWithSlider<MarkInPictureQuestionDownloadDto> getter={x => x.paddingRight} min={0} max={10} /> },
                        { label: { icon: "tag", content: "paddingBottom" }, editor: <EditNumberWithSlider<MarkInPictureQuestionDownloadDto> getter={x => x.paddingBottom} min={0} max={10} /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
            <PrePostFixQuestion epc={epc} registerClosed={registerClosed} />
        </>
    );
}
export default PostEditQuizMarkInPictureQuestion;